import { render, staticRenderFns } from "./SetupProgress.vue?vue&type=template&id=68b00a4f&"
import script from "./SetupProgress.vue?vue&type=script&lang=js&"
export * from "./SetupProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports